import { render, staticRenderFns } from "./add_association.vue?vue&type=template&id=3fb02faa&scoped=true"
import script from "./add_association.vue?vue&type=script&lang=js"
export * from "./add_association.vue?vue&type=script&lang=js"
import style0 from "./add_association.vue?vue&type=style&index=0&id=3fb02faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb02faa",
  null
  
)

export default component.exports